import { Entity } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { TopRankIcon } from '~/widgets/knowledge-graph-widget/components/top-rank-icon/TopRankIcon';

import { GeographicStepperSection } from '../geographic-stepper-section/GeographicStepperSection';
import { GeoSourceEvidenceSection } from '../source-evidence-section/GeoSourceEvidenceSection';
import * as S from './GeoExposureDetails.styles';

export interface GeoExposureDetailsProps {
  entity: Entity;
  targetName: string;
  targetType: 'country' | 'region';
  title: string;
  rankTitle: string;
  description: string;
  rank: number;
  evidence?: string[] | null;
  sourceEvidence?: string | null;
  withDivider?: boolean;
}

export const GeoExposureDetails = ({
  entity,
  targetName,
  targetType,
  title,
  rankTitle,
  description,
  rank,
  evidence,
  sourceEvidence,
  withDivider,
}: GeoExposureDetailsProps) => {
  const { t } = useTranslation(['widget']);
  return (
    <S.Root>
      <GeographicStepperSection
        entity={entity}
        targetName={targetName}
        targetType={targetType}
        title={title}
        activeIndex={0}
        description={description}
      />
      <S.SectionRow>
        <S.TitleBase>{rankTitle}</S.TitleBase>
        <S.StyledRankWrapper>
          <S.RankContainer>
            <S.RankLabel>
              {t(
                'widget:assetOverview.knowledgeGraph.themeExposure.tabs.themeExposure.current'
              )}
            </S.RankLabel>
            <S.RankFlexRow>
              <TopRankIcon rank={rank} />
            </S.RankFlexRow>
          </S.RankContainer>
        </S.StyledRankWrapper>
      </S.SectionRow>
      <ErrorBoundaryWrapper>
        <GeoSourceEvidenceSection
          evidence={evidence ?? []}
          sourceEvidence={sourceEvidence ?? null}
        />
      </ErrorBoundaryWrapper>
      {withDivider ? <S.HorizontalDivider /> : null}
    </S.Root>
  );
};
